<template>
  <div class="flex-box">
    <div class="search-box">
      <div>
        <label class="searchItemName">账号：</label>
        <el-input class="input-box" placeholder="锁定帐户" v-model="queryParams.account" clearable
          @keyup.enter.native="search()"></el-input>
      </div>
      <div>
        <label class="searchItemName">IP：</label>
        <el-input class="input-box" placeholder="IP地址" v-model="queryParams.ipAddress" clearable
          @keyup.enter.native="search()"></el-input>
      </div>
      <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="search()">查询</el-button>
    </div>
    <el-table :data="tableData" border style="width: 100%; margin: 15px 0;">
      <el-table-column prop="account" label="锁定帐户" min-width="160" align="center"></el-table-column>
      <el-table-column prop="ipAddress" label="IP地址" min-width="160" align="center"></el-table-column>
      <el-table-column prop="lockTime" label="锁定时间" min-width="180" align="center"></el-table-column>
      <el-table-column label="操作" width="120" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="danger" size="mini" plain @click="remove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="queryParams.pageIndex" :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next" :total="total">
    </el-pagination>
  </div>
</template>

<script>
import listPage from '../../../mixins/listPage.js'
import { post } from '../../../../public/request/request.js'

export default {
  mixins: [listPage],
  data() {
    return {
      total: 0,
      queryParams: { pageIndex: 1, pageSize: 10, account: '', ipAddress: '' },
      tableData: []
    }
  },
  created() { this.GetData() },
  methods: {
    search() {
      this.queryParams.pageIndex = 1
      this.GetData()
    },
    GetData() {
      const loading = this.openLoading()
      post(404, {
        pageIndex: this.queryParams.pageIndex,
        pageSize: this.queryParams.pageSize,
        account: (this.queryParams.account || '').trim(),
        ipAddress: (this.queryParams.ipAddress || '').trim()
      }).then(response => {
        loading.close()
        if (response.data.result == 0) {
          const data = response.data.data || {}
          this.tableData = Array.isArray(data.list) ? data.list : []
          this.total = Number(data.pageCount) || 0
        } else {
          this.tableData = []
          this.total = 0
          this.$message.error('查询失败：' + response.data.message)
        }
      }).catch(error => {
        loading.close()
        this.tableData = []
        this.total = 0
        this.$message.error((error && error.userMessage) || '查询失败')
      })
    },
    remove(row) {
      this.$confirm(`确认解除锁定 IP「${row.ipAddress}」吗？`, '提示', {
        type: 'warning',
        confirmButtonText: '删除',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.openLoading()
        post(405, { objId: row.id }).then(response => {
          loading.close()
          if (response.data.result == 0) {
            this.$message.success('删除成功')
            if (this.tableData.length === 1 && this.queryParams.pageIndex > 1) {
              this.queryParams.pageIndex -= 1
            }
            this.GetData()
          } else {
            this.$message.error('删除失败：' + response.data.message)
          }
        }).catch(error => {
          loading.close()
          this.$message.error((error && error.userMessage) || '删除失败')
        })
      }).catch(() => {})
    }
  }
}
</script>
